export const MOTIVE = ['Cambio de Horario','Farmacia de turno','Cerrado por feriado', 'Cerrado por vacaciones', 'Cerrado por duelo', 'Cerrado']